import { api } from '@/lib/api';
import type {
  FunnelAnalyticsRequest,
  FunnelAnalyticsResponse,
  LeadConversionRequest,
  LeadConversionResponse,
  ActivityReportRequest,
  ActivityReportResponse,
  TeamPerformanceRequest,
  TeamPerformanceResponse,
  CRMDashboardRequest,
  CRMDashboardResponse,
} from '@troia-v3/types';

/**
 * Service para relatórios CRM
 */
export const crmReportsApi = {
  /**
   * Get funnel analytics with step conversion rates
   */
  async getFunnelAnalytics(params: FunnelAnalyticsRequest): Promise<FunnelAnalyticsResponse[]> {
    const response = await api.get('crm-reports/funnel-analytics', { params });
    return response.data.data;
  },

  /**
   * Get lead conversion report with breakdown by period, source, and origin
   */
  async getLeadConversion(params: LeadConversionRequest): Promise<LeadConversionResponse> {
    const response = await api.get('crm-reports/lead-conversion', { params });
    return response.data.data;
  },

  /**
   * Get activity report with overdue tracking
   */
  async getActivityReport(params: ActivityReportRequest): Promise<ActivityReportResponse> {
    const response = await api.get('crm-reports/activity-report', { params });
    return response.data.data;
  },

  /**
   * Get team performance report
   */
  async getTeamPerformance(params: TeamPerformanceRequest): Promise<TeamPerformanceResponse> {
    const response = await api.get('crm-reports/team-performance', { params });
    return response.data.data;
  },

  /**
   * Get CRM dashboard summary
   */
  async getDashboard(params: CRMDashboardRequest): Promise<CRMDashboardResponse> {
    const response = await api.get('crm-reports/dashboard', { params });
    return response.data.data;
  },
};
